import message from '@devdept/samolet-ui/lib/components/message';

export default message;
export { requestErrorMessage, inDevMessage, errorMessage } from './message';
